import axios from 'axios';
import { AppStartSettingsModel, AppSettingsModel } from '@/types';
import { Logger } from '@/classes/Logger';

const AppSettingsApiUrl = 'appSettings/';
const AppStartSettingsApiUrl = `${AppSettingsApiUrl}getappstartsettings`;

export const AppSettingsService = {
  getAppStartSettings(baseUrl?: string): AppStartSettingsModel {
    const url = baseUrl === undefined ? AppStartSettingsApiUrl : baseUrl.concat(AppStartSettingsApiUrl);
    let appSettings: AppStartSettingsModel = {
      baseUrl: '',
      authServerAuthority: '',
      sessionId: '',
      idleTimeout: 60,
      maximumNumberOfPagesToCache: 15
    };
    
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.setRequestHeader('Pragma', 'no-cache');
    
    try {
      xhr.send();
      if (xhr.status === 200) {
        appSettings = JSON.parse(xhr.responseText);
      } else {
        Logger.$log(`Failed to get app start settings. Status: ${xhr.status}, Response: ${xhr.responseText}`);
      }
    } catch (error) {
      Logger.$log(`Failed to get app start settings. Error: ${JSON.stringify(error)}`);
    }

    return appSettings;
  },
  getAppSettings(baseUrl?: string): AppStartSettingsModel {
    const url = baseUrl === undefined ? AppSettingsApiUrl : baseUrl.concat(AppSettingsApiUrl);
    let appSettings: AppStartSettingsModel = {
      baseUrl: '',
      authServerAuthority: '',
      sessionId: '',
      idleTimeout: 60,
      maximumNumberOfPagesToCache: 15
    };
    
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.setRequestHeader('Pragma', 'no-cache');
    
    try {
      xhr.send();
      if (xhr.status === 200) {
        appSettings = JSON.parse(xhr.responseText);
      } else {
        Logger.$log(`Failed to get app settings. Status: ${xhr.status}, Response: ${xhr.responseText}`);
      }
    } catch (error) {
      Logger.$log(`Failed to get app settings. Error: ${JSON.stringify(error)}`);
    }

    return appSettings;
  },
  async getAppSettingsAsync(): Promise<AppSettingsModel> {
    const response = await axios.get(AppSettingsApiUrl);
    return response.data;
  }
};
